import { Component, computed, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IPostMetadataTags } from '../models/Metadata-tags';
import { MetadataTagsFacade } from '../facade/metadata-tags.facade';

@Component({
  selector: 'app-create-metadata-tag',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './create-metadata-tags.html',
})
export class CreateMetadataTagComponent implements OnInit {
  private fb = inject(FormBuilder);
  private metadataTagsFacade = inject(MetadataTagsFacade);

  metadataTagForm!: FormGroup;
  tagPairs: IPostMetadataTags[] = [];
  public objectKeys = Object.keys;

  metadataTags = computed(() => {
    const tags = this.metadataTagsFacade.metadataTagsSignal() || [];
    return tags.slice().sort((a, b) => {
      const keyCompare = a.key.localeCompare(b.key);
      return keyCompare !== 0 ? keyCompare : a.value.localeCompare(b.value);
    });
  });

  groupedMetadataTags = computed(() => {
    const tags = this.metadataTags();
    const grouped: { [key: string]: string[] } = {};

    for (const tag of tags) {
      if (!grouped[tag.key]) {
        grouped[tag.key] = [];
      }
      grouped[tag.key].push(tag.value);
    }

    return grouped;
  });

  ngOnInit(): void {
    this.metadataTagForm = this.fb.group({
      key: ['', Validators.required],
      value: ['', Validators.required],
    });

    this.metadataTagsFacade.getMetadataTags();
  }

  addPair(): void {
    if (this.metadataTagForm.invalid) return;

    const { key, value } = this.metadataTagForm.value;
    this.tagPairs.push({ key, value });
    this.metadataTagForm.get('value')?.reset();
  }

  submitForm(): void {
    for (const tag of this.tagPairs) {
      this.metadataTagsFacade.postMetadataTags(tag);
    }
    this.tagPairs = [];
    this.metadataTagForm.reset();
  }

  deleteTag(id: number) {
    this.metadataTagsFacade.deleteMetadataTags(id);
  }

  removePendingTag(index: number) {
    this.tagPairs.splice(index, 1);
  }

  deleteTagByKeyValue(key: string, value: string) {
    const tagToDelete = this.metadataTags().find((tag) => tag.key === key && tag.value === value);
    if (tagToDelete) {
      this.metadataTagsFacade.deleteMetadataTags(tagToDelete.id);
    }
  }
}
